var _rect, _path, _g, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCanvasNavMouseMoveAround = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 65,
    viewBox: "0 0 62 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.167969,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#9C64FF",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0482 24.2665V26.6339M31.0482 40.8383C36.2782 40.8383 40.5179 36.5987 40.5179 31.3687V26.6339C40.5179 21.404 36.2782 17.1643 31.0482 17.1643C25.8183 17.1643 21.5786 21.404 21.5786 26.6339V31.3687C21.5786 36.5987 25.8183 40.8383 31.0482 40.8383Z",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4145_3601)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_4145_3601",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5254 26.9115C31.5254 25.2474 32.8744 23.8984 34.5384 23.8984C36.2025 23.8984 37.5515 25.2474 37.5515 26.9115V34.1954C39.6477 34.383 41.9544 34.7225 43.3123 35.062C45.3425 35.5695 47.8802 37.3708 47.8802 40.1373L47.8802 44.1977C47.8802 45.7203 47.4724 50.7964 39.8094 50.7964C36.6651 50.7964 34.811 50.0222 33.7176 48.7606L26.1579 41.2009C24.9812 40.0242 24.9812 38.1164 26.1579 36.9398C27.3346 35.7631 29.2423 35.7631 30.419 36.9398L31.5254 38.0461V26.9115Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5254 26.9115C31.5254 25.2474 32.8744 23.8984 34.5384 23.8984C36.2025 23.8984 37.5515 25.2474 37.5515 26.9115V34.1954C39.6477 34.383 41.9544 34.7225 43.3123 35.062C45.3425 35.5695 47.8802 37.3708 47.8802 40.1373L47.8802 44.1977C47.8802 45.7203 47.4724 50.7964 39.8094 50.7964C36.6651 50.7964 34.811 50.0222 33.7176 48.7606L26.1579 41.2009C24.9812 40.0242 24.9812 38.1164 26.1579 36.9398C27.3346 35.7631 29.2423 35.7631 30.419 36.9398L31.5254 38.0461V26.9115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5515 34.1954H35.5515V36.0244L37.3732 36.1874L37.5515 34.1954ZM43.3123 35.062L43.7974 33.1217L43.3123 35.062ZM47.8802 40.1373H45.8802V40.1374L47.8802 40.1373ZM47.8802 44.1977H49.8802V44.1976L47.8802 44.1977ZM33.7176 48.7606L35.2291 47.4508L35.1823 47.3969L35.1319 47.3464L33.7176 48.7606ZM26.1579 41.2009L24.7437 42.6151H24.7437L26.1579 41.2009ZM26.1579 36.9398L27.5721 38.354L27.5721 38.354L26.1579 36.9398ZM31.5254 38.0461L30.1112 39.4603L33.5254 42.8746V38.0461H31.5254ZM34.5384 21.8984C31.7698 21.8984 29.5254 24.1429 29.5254 26.9115H33.5254C33.5254 26.352 33.9789 25.8984 34.5384 25.8984V21.8984ZM39.5515 26.9115C39.5515 24.1429 37.3071 21.8984 34.5384 21.8984V25.8984C35.0979 25.8984 35.5515 26.352 35.5515 26.9115H39.5515ZM39.5515 34.1954V26.9115H35.5515V34.1954H39.5515ZM43.7974 33.1217C42.2959 32.7463 39.8736 32.3952 37.7298 32.2033L37.3732 36.1874C39.4218 36.3708 41.6128 36.6986 42.8273 37.0022L43.7974 33.1217ZM49.8802 40.1373C49.8802 38.092 48.9301 36.459 47.7485 35.3154C46.5871 34.1914 45.1243 33.4534 43.7974 33.1217L42.8273 37.0022C43.5305 37.178 44.3517 37.5945 44.9667 38.1897C45.5614 38.7652 45.8802 39.4161 45.8802 40.1373H49.8802ZM49.8802 44.1976L49.8802 40.1373L45.8802 40.1374L45.8802 44.1977L49.8802 44.1976ZM39.8094 52.7964C44.1233 52.7964 46.8165 51.3365 48.3367 49.2432C49.771 47.2683 49.8802 45.0978 49.8802 44.1977H45.8802C45.8802 44.8201 45.7855 45.949 45.1002 46.8927C44.5007 47.7182 43.1585 48.7964 39.8094 48.7964V52.7964ZM32.2062 50.0704C33.8326 51.9471 36.3691 52.7964 39.8094 52.7964V48.7964C36.961 48.7964 35.7893 48.0973 35.2291 47.4508L32.2062 50.0704ZM35.1319 47.3464L27.5721 39.7867L24.7437 42.6151L32.3034 50.1748L35.1319 47.3464ZM27.5721 39.7867C27.1765 39.391 27.1765 38.7496 27.5721 38.354L24.7437 35.5255C22.786 37.4833 22.786 40.6574 24.7437 42.6151L27.5721 39.7867ZM27.5721 38.354C27.9677 37.9583 28.6092 37.9583 29.0048 38.354L31.8332 35.5255C29.8755 33.5678 26.7014 33.5678 24.7437 35.5255L27.5721 38.354ZM29.0048 38.354L30.1112 39.4603L32.9396 36.6319L31.8332 35.5255L29.0048 38.354ZM29.5254 26.9115V38.0461H33.5254V26.9115H29.5254Z",
    fill: "#50307E",
    mask: "url(#path-3-inside-1_4145_3601)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5977 14.7969L13.9267 14.7969M21.5977 14.7969L19.5977 12.7969M21.5977 14.7969L19.5977 16.7969",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8438 8L14.8438 15.671M14.8438 8L12.8438 10M14.8438 8L16.8438 10",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8437 21.3281L14.8437 13.6572M14.8437 21.3281L16.8437 19.3281M14.8437 21.3281L12.8438 19.3281",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16797 14.7969L15.8389 14.7969M8.16797 14.7969L10.168 16.7969M8.16797 14.7969L10.168 12.7969",
    stroke: "#50307E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4145_3601",
    x: 19.2754,
    y: 17.8984,
    width: 42.6049,
    height: 46.8979,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.313726 0 0 0 0 0.188235 0 0 0 0 0.494118 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4145_3601"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4145_3601",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCanvasNavMouseMoveAround);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/canvas_nav_mouse_move_around.cd769449612a63fbf3b24c2f3402fec7.svg";